import { render, staticRenderFns } from "./MenuModelB.vue?vue&type=template&id=675b16b4"
import script from "./MenuModelB.vue?vue&type=script&lang=js"
export * from "./MenuModelB.vue?vue&type=script&lang=js"
import style0 from "./MenuModelB.vue?vue&type=style&index=0&id=675b16b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports